export { OffersGroupsDetails as default } from 'pages/loyalty/loyalty-offers/loyalty-offers-groups-details';
